import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { BrandBand } from "@/components/BrandBand";
import { Marquee } from "@/components/Marquee";
import { Intro } from "@/components/Intro";
import { Services } from "@/components/Services";
import { Work } from "@/components/Work";
import { Transformation } from "@/components/Transformation";
import { Process } from "@/components/Process";
import { WhoWeFor } from "@/components/WhoWeFor";
import { Founder } from "@/components/Founder";
import { Packages } from "@/components/Packages";
import { Testimonials } from "@/components/Testimonials";
import { AdSection } from "@/components/AdSection";
import { Gallery } from "@/components/Gallery";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";

const Landing = () => {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, anchors: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <>
            <Nav />
            <main>
                <Hero />
                <BrandBand />
                <Marquee />
                <Intro />
                <Services />
                <Work />
                <Transformation />
                <Process />
                <WhoWeFor />
                <Founder />
                <Packages />
                <Testimonials />
                <AdSection />
                <Gallery />
                <Contact />
            </main>
            <Footer />
        </>
    );
};

function App() {
    return (
        <BrowserRouter>
            <div className="App bg-[#0A0A0A] text-[#F1F1EF] min-h-screen">
                <div className="grain-overlay" aria-hidden="true" />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
                <Toaster position="bottom-center" richColors />
            </div>
        </BrowserRouter>
    );
}

export default App;
